$(function () {
  $('body').on('click', '#preferences a.sso-account', function (e) {
    e.preventDefault();
    NIRV.gotoAccount();
  });

  // GLOBAL AREA FILTERING
  $('body').on('click', '#preferences #UIAreaFiltering-inclusive', function () {
    NIRV.setPref('UIAreaFiltering', 'inclusive', 'true');
  });
  $('body').on('click', '#preferences #UIAreaFiltering-exclusive', function () {
    NIRV.setPref('UIAreaFiltering', 'exclusive', 'true');
  });

  // TASK COUNTS
  $('body').on('click', '#preferences #UICounts-default', function () {
    NIRV.setPref('UICounts', '', true);
  });
  $('body').on('click', '#preferences #UICounts-all', function () {
    NIRV.setPref('UICounts', 'all', true);
  });

  // PROJECTS
  $('body').on(
    'click',
    '#preferences #UIDefaultProjectType-parallel',
    function () {
      NIRV.setPref('UIDefaultProjectType', '0', 'true');
    }
  );
  $('body').on(
    'click',
    '#preferences #UIDefaultProjectType-sequential',
    function () {
      NIRV.setPref('UIDefaultProjectType', '1', 'true');
    }
  );

  // LATER
  $('body').on('click', '#preferences #UIEnableLater-yes', function () {
    NIRV.setPref('UIEnableLater', '1', 'true');
  });
  $('body').on('click', '#preferences #UIEnableLater-no', function () {
    NIRV.setPref('UIEnableLater', '0', 'true');
  });

  // INBOX AND AREAS
  $('body').on('click', '#preferences #UIAreaAssignment-yes', function () {
    NIRV.setPref('UIAreaAssignment', '1', 'true');
  });
  $('body').on('click', '#preferences #UIAreaAssignment-no', function () {
    NIRV.setPref('UIAreaAssignment', '0', 'true');
  });

  // RAPID ENTRY
  $('body').on('click', '#preferences #UIEnableRapidEntry-yes', function () {
    NIRV.setPref('UIEnableRapidEntry', '1', 'true');
  });
  $('body').on('click', '#preferences #UIEnableRapidEntry-no', function () {
    NIRV.setPref('UIEnableRapidEntry', '0', 'true');
  });

  // LOGBOOK
  $('body').on('change', '#preferences #UICollectCompleted', function (e) {
    NIRV.setPref('UICollectCompleted', e.target.value, 'true');
  });

  // COMPLETED
  $('body').on(
    'click',
    '#preferences #UIBLeaveCompletedInPlace-yes',
    function () {
      NIRV.setPref('UIBLeaveCompletedInPlace', '1', 'true');
    }
  );
  $('body').on(
    'click',
    '#preferences #UIBLeaveCompletedInPlace-no',
    function () {
      NIRV.setPref('UIBLeaveCompletedInPlace', '0', 'true');
    }
  );

  // LOOK & FEEL

  // Appearance - light | dark | auto
  $('body').on('change', '#preferences #UIBAppearance', function (e) {
    NIRV.setPref('UIBAppearance', e.target.value, 'true');
  });

  // Color Theme - blue | pink | orange ...
  $('body').on('change', '#preferences #UIBThemeName', function (e) {
    NIRV.setPref('UIBThemeName', e.target.value, 'true');
  });

  // Background - light (snow) | dark (slate)
  $('body').on('change', '#preferences #UIBThemeBackground', function (e) {
    NIRV.setPref('UIBThemeBackground', e.target.value, 'true');
  });

  // Density - comfortable | compact
  $('body').on('change', '#preferences #UIBDensity', function (e) {
    NIRV.setPref('UIBDensity', e.target.value, 'true');
  });

  // Font Family - proxima-nova | trebuchet
  $('body').on('change', '#preferences #UIB3FontFamily', function () {
    NIRV.setPref('UIB3FontFamily', $(this).val(), 'true');
  });

  // Language - en | es | fr ...
  $('body').on('change', '#preferences #UILanguage', function () {
    var newLanguage = $(this).val();
    NIRV.setPref('UILanguage', newLanguage, 'true');

    // Auto-update date locale to match language (Option B behavior)
    // Users can still override this manually in the date format dropdown
    var suggestedDateLocale;
    switch (newLanguage) {
      case 'es':
        suggestedDateLocale = 'es-ES';
        break;
      case 'fr':
        suggestedDateLocale = 'fr-FR';
        break;
      case 'ja':
        suggestedDateLocale = 'ja-JP';
        break;
      case 'en':
      default:
        suggestedDateLocale = 'en-US';
        break;
    }

    // Only auto-update if the current date locale is still at default or matches the old language
    // This prevents overriding explicit user choices
    var currentDateLocale = NIRV.prefs['UIDateLocale'].value;
    var shouldAutoUpdate =
      currentDateLocale === 'en-US' || // Default value
      currentDateLocale === 'es-ES' || // Previous auto-set value
      currentDateLocale === 'fr-FR' || // Previous auto-set value
      currentDateLocale === 'ja-JP' || // Previous auto-set value
      currentDateLocale === 'en-GB'; // Other default option

    if (shouldAutoUpdate && currentDateLocale !== suggestedDateLocale) {
      NIRV.setPref('UIDateLocale', suggestedDateLocale, 'true');
      // Update the date locale dropdown to reflect the change
      $('#preferences #UIDateLocale').val(suggestedDateLocale);
    }

    // Always refresh the settings dialog to update language text and date examples
    // Use a more robust approach to wait for language change completion
    var refreshSettings = function () {
      if (window.NirvanaI18next && window.NirvanaI18next.initialized) {
        // Language system is ready, refresh immediately
        NIRV.appSettings();
        NIRV.refreshAll('force'); // Ensure UI reflects new language
      } else {
        // Not ready yet, try again in a moment
        setTimeout(refreshSettings, 100);
      }
    };

    // Start the refresh process after a short delay
    setTimeout(refreshSettings, 100);
  });

  // DATE FORMAT
  $('body').on('change', '#preferences #UIDateLocale', function () {
    NIRV.setPref('UIDateLocale', $(this).val(), 'true');
    // Refresh settings dialog to update date format examples
    setTimeout(function () {
      NIRV.appSettings();
    }, 50); // Short delay to ensure preference is saved
  });

  // CALENDAR WEEK
  $('body').on('click', '#preferences #UIDateWeekStartsOnSun', function () {
    NIRV.setPref('UIDateWeekStartsOn', '0', 'true');
  });
  $('body').on('click', '#preferences #UIDateWeekStartsOnMon', function () {
    NIRV.setPref('UIDateWeekStartsOn', '1', 'true');
  });

  // DUE DATES
  $('body').on('click', '#preferences #UIRelativeDueDates-enable', function () {
    NIRV.setPref('UIRelativeDueDates', '1', 'true');
  });
  $('body').on(
    'click',
    '#preferences #UIRelativeDueDates-disable',
    function () {
      NIRV.setPref('UIRelativeDueDates', '0', 'true');
    }
  );
});
